import React, { useState } from "react";
import {
  Box,
  Button,
  Input,
  Text,
  Spinner,
  SimpleGrid,
} from "@chakra-ui/react";
import Card from "components/card/Card";
import { motion } from "framer-motion";
import fetchWithToken from "views/auth/signIn/axiosInstance";
import { useTranslation } from "react-i18next";

const CreateSetting = () => {
  const { t } = useTranslation();
  const [deliveryFee, setDeliveryFee] = useState("");
  const [cleanAtLocationFee, setCleanAtLocationFee] = useState("");
  const [deliveryFeeRange, setDeliveryFeeRange] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const page = 18;
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError("");
    setSuccess("");

    const payload = {
      fees: [
        { key: "delivery_fee", value: deliveryFee },
        { key: "clean_at_location_fee", value: cleanAtLocationFee },
        { key: "delivery_fee_range", value: deliveryFeeRange },
      ],
    };

    try {
      const response = await fetchWithToken(
        `${process.env.REACT_APP_API_URL}/settings/create?page_id=${page}`,
        "POST",
        JSON.stringify(payload),
        { "Content-Type": "application/json" }
      );

      // Assuming the API returns a response with a "status" field
      if (response && response.status === "success") {
        setSuccess(response.message || t("Fees stored successfully"));
        setDeliveryFee("");
        setCleanAtLocationFee("");
        setDeliveryFeeRange("");
      } else {
        // If not successful, try to parse error message
        const errorData = await response.json();
        setError(errorData.message || t("An error occurred"));
      }
    } catch (err) {
      setError(err.message || t("An error occurred. Please try again later."));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.5 }}
    >
      <Card p={{ base: "20px", md: "30px" }}>
        {error && (
          <Text color="red.500" mb={4} textAlign="center">
            {error}
          </Text>
        )}
        {success && (
          <Text color="green.500" mb={4} textAlign="center">
            {success}
          </Text>
        )}
        <form onSubmit={handleSubmit}>
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
            <Box>
              <Text mb="2" fontSize="sm" color="gray.800">
                {t("Delivery Fee")}
              </Text>
              <Input
                type="text"
                value={deliveryFee}
                onChange={(e) => setDeliveryFee(e.target.value)}
                placeholder="e.g., 5.00"
                required
              />
            </Box>
            <Box>
              <Text mb="2" fontSize="sm" color="gray.800">
                {t("Clean at Location Fee")}
              </Text>
              <Input
                type="text"
                value={cleanAtLocationFee}
                onChange={(e) => setCleanAtLocationFee(e.target.value)}
                placeholder="e.g., 10.00"
                required
              />
            </Box>
            <Box gridColumn={{ base: 1, md: 2 }}>
              <Text mb="2" fontSize="sm" color="gray.800">
                {t("Delivery Fee Range")}
              </Text>
              <Input
                type="text"
                value={deliveryFeeRange}
                onChange={(e) => setDeliveryFeeRange(e.target.value)}
                placeholder="e.g., 5.00-10.00"
                required
              />
            </Box>
          </SimpleGrid>
          <Button
            mt={6}
            type="submit"
            colorScheme="cyan"
            color={"white"}
            w={{ base: "100%", md: "200px" }}
            isLoading={isSubmitting}
          >
            {t("Create Settings")}
          </Button>
        </form>
      </Card>
    </motion.div>
  );
};

export default CreateSetting;
